import React, { useState, useRef, useEffect } from 'react';
import './DropdownList.css';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

function DropdownList({ placeholder, options, selectedOption, onSelect, className }) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState(''); // texto digitado para filtrar
  const dropdownRef = useRef();

  // UseEffect para adicionar um ouvinte de eventos de clique ao documento
  useEffect(() => {
    function handleOutsideClick(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        // Clique fora da lista suspensa, então feche-a e limpa o filtro
        setIsOpen(false);
        setSearchTerm('');
      }
    }

    // Adicione o ouvinte de eventos quando a lista suspensa estiver aberta
    if (isOpen) {
      document.addEventListener('click', handleOutsideClick);
    } else {
      document.removeEventListener('click', handleOutsideClick);
    }

    // Limpe o ouvinte de eventos quando o componente é desmontado
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [isOpen]);

  // Normaliza (minúsculas, sem acento) para comparar de forma tolerante
  const normalizar = (texto) =>
    String(texto ?? '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '');

  const filteredOptions = options.filter((option) =>
    normalizar(option).includes(normalizar(searchTerm))
  );

  const handleOptionClick = (option) => {
    onSelect(option);
    setSearchTerm('');
    setIsOpen(false);
  };

  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
    setIsOpen(true);
  };

  const handleInputFocus = () => {
    // Ao focar, abre a lista e zera o filtro para mostrar todas as opções
    setIsOpen(true);
    setSearchTerm('');
  };

  const toggleDropdown = () => {
    setIsOpen((aberto) => {
      if (aberto) setSearchTerm('');
      return !aberto;
    });
  };

  return (
    <div ref={dropdownRef} className={`dropdown-list ${className || ''}`}>
      <div className="selected-option">
        <input
          type="text"
          className="dropdown-input"
          placeholder={placeholder}
          // Enquanto aberto mostra o que está sendo digitado; fechado, mostra o selecionado
          value={isOpen ? searchTerm : selectedOption || ''}
          onChange={handleInputChange}
          onFocus={handleInputFocus}
        />
        <ArrowDropDownIcon className="dropdown-arrow" onClick={toggleDropdown} />
      </div>
      {isOpen && (
        <ul className="options">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => (
              <li className="item" key={index} onClick={() => handleOptionClick(option)}>
                {option}
              </li>
            ))
          ) : (
            <li className="item item-vazio">Nenhum resultado</li>
          )}
        </ul>
      )}
    </div>
  );
}

export default DropdownList;
